import { SoChipType } from "@/types/components/SoChip"
import { WarrantsJobStatus } from "@/models/admin/warrantsJob/warrantsJob.types"
import { WarrantsAccountState } from "@/models/admin/warrantsAccount/warrantsAccount.types"
import { WarrantsFilesJobStatus } from "@/models/admin/warrantsFilesJob/warrantsFilesJob.types"
import { WarrantsFilesAccountStatus } from "@/models/admin/warrantsFilesAccount/warrantsFilesAccount.types"

/** Maps a warrants_job status to the chip colour used in the Jobs table. */
export function jobStatusChipType(status: WarrantsJobStatus): SoChipType {
  switch (status) {
    case WarrantsJobStatus.COMPLETED:
      return SoChipType.SUCCESS
    case WarrantsJobStatus.FAILED:
      return SoChipType.ERROR
    case WarrantsJobStatus.STARTED:
      return SoChipType.IMPORTANT
    default:
      return SoChipType.DEFAULT
  }
}

/** Maps a warrants_files_job status to the chip colour used in the Jobs table. */
export function filesJobStatusChipType(
  status: WarrantsFilesJobStatus,
): SoChipType {
  switch (status) {
    case WarrantsFilesJobStatus.COMPLETED:
      return SoChipType.SUCCESS
    case WarrantsFilesJobStatus.FAILED:
      return SoChipType.ERROR
    case WarrantsFilesJobStatus.STARTED:
      return SoChipType.IMPORTANT
    default:
      return SoChipType.DEFAULT
  }
}

/** Maps a warrants_files_account status to the chip colour used in the Accounts table. */
export function filesAccountStatusChipType(
  status: WarrantsFilesAccountStatus,
): SoChipType {
  switch (status) {
    case WarrantsFilesAccountStatus.SUCCESS:
      return SoChipType.SUCCESS
    case WarrantsFilesAccountStatus.FAILED:
      return SoChipType.ERROR
    case WarrantsFilesAccountStatus.PENDING:
      return SoChipType.IMPORTANT
    default:
      return SoChipType.DEFAULT
  }
}

/** Maps a warrants_account_state to the chip colour used in the Accounts table. */
export function accountStateChipType(state: WarrantsAccountState): SoChipType {
  switch (state) {
    case WarrantsAccountState.WARRANT_PHASE_COMPLETED:
      return SoChipType.SUCCESS
    case WarrantsAccountState.PENDING:
      return SoChipType.DEFAULT
    default:
      return SoChipType.WARNING
  }
}
